import { Fragment } from "react";
import { Link } from "react-router-dom";

export const Home = () => (
    <Fragment>
        <li><Link to="/">Home One</Link></li>
        <li><Link to="/home-two">Home Two</Link></li>
        <li><Link to="/home-three">Home Three</Link></li>
    </Fragment>
);
export const Services = () => (
    <Fragment>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/services-details">Services Details</Link></li>
    </Fragment>
);
export const Works = () => (
    <Fragment>
        {/* <li><Link to="/projects">Research & Development Projects</Link></li>
        <li><Link to="/projects">Softwares</Link></li>
        <li><Link to="/projects-details">Projects Details</Link></li>
        <li><Link to="/pricing">Pricing</Link></li>
        <li><Link to="/team">Team</Link></li>
        <li><Link to="/testimonial">Testimonial</Link></li> */}
    </Fragment>
);

export const News = () => (
    <Fragment>
        <li><Link to="/blog">Blog</Link></li>
        <li><Link to="/blog-details">Blog Details</Link></li>
    </Fragment>
);

export const About = () => (
    <Fragment>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/about#certifications">Certifications</Link></li>
        <li><Link to="/about#team-members">Team</Link></li>
        <li><Link to="/about#partners">HR & Legal</Link></li>
        <li><Link to="/about#founder">Meet Our Founder</Link></li>
        <li><Link to="/about#gallery">Gallery</Link></li>
        <li><Link to="/partners">Partners & Customers</Link></li>
    </Fragment>
);
